import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=490a2810"
import script from "./cropper.vue?vue&type=script&lang=js"
export * from "./cropper.vue?vue&type=script&lang=js"
import style0 from "./cropper.vue?vue&type=style&index=0&id=490a2810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports